import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmailEditor from "@Shared/components/inputs/email-editor";
import SyncEmailsModal from "./sync-emails-modal";
import EmailActionsDropdown from "./email-actions-dropdown";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import ScheduleModal from "@Broker/@Modules/dashboard/components/schedule-modal.vue";
import { REFRESH_TOKEN_NYLAS, UPDATE_REFRESH_TOKEN, DELETE_SYNCED_EMAIL } from "@Broker/@Modules/settings/store/settings-actions";
import { mapActions } from "vuex";
import { defineComponent } from "@vue/composition-api";
import { NYLAS_CLIENT_ID } from "@Shared/utils/constants";
import { isEmpty } from "lodash";
import { showToast } from "@Shared/@Utils/constants";
export default defineComponent({
  name: "EmailPreferences",
  components: {
    EmailEditor,
    SyncEmailsModal,
    EmailActionsDropdown,
    ScheduleModal,
    SimpleButton
  },
  props: {
    accountPreferences: {
      type: Object,
      required: true
    },
    syncedEmails: {
      type: Object,
      required: true
    },
    nylasAccount: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      syncEmailsModalOpen: false,
      editEmail: false,
      emailSignature: this.accountPreferences.emailSignature,
      resyncEmail: false,
      shouldDisplayScheduler: false
    };
  },
  computed: {
    isEmailsEmpty() {
      return this.syncedEmails.allIds.length;
    },
    editEmailButtonText() {
      return this.editEmail ? this.$t("settings.accountTab.showPreview") : this.$t("settings.accountTab.editSignature");
    }
  },
  async mounted() {
    var _context;
    if (_includesInstanceProperty(_context = window.location.href).call(_context, "redirect=")) {
      await this.$nextTick();
      await this.initiateNylas(true, null);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [REFRESH_TOKEN_NYLAS, UPDATE_REFRESH_TOKEN, DELETE_SYNCED_EMAIL])), {}, {
    handleToggleEditEmail() {
      this.editEmail = !this.editEmail;
    },
    isNylasAccountConnected() {
      return !isEmpty(this.nylasAccount);
    },
    handleSubmit() {
      this.$emit("submit", this.emailSignature);
    },
    handleEditorChange({
      content
    }) {
      this.$emit("allow-save", true);
      this.emailSignature = content;
    },
    resyncEmailModal() {
      this.resyncEmail = true;
    },
    connectEmailModal() {
      this.resyncEmail = false;
    },
    handleAppointmentClick(email) {
      this.initiateNylas(false, email.nylasAccountId);
    },
    async deleteOldEmailSync() {
      await this.DELETE_SYNCED_EMAIL(this.nylasAccount.grantId);
      this.$emit("clear-nylas-account");
      showToast("success", "deleteOldSyncedEmail");
    },
    async initiateNylas(redirect = false, nylasAccountId = null) {
      const identity = require("../../../dashboard/components/nylas-scripts/nylas-identity.es.js");
      const requestWrapper = require("../../../dashboard/components/nylas-scripts/request-wrapper.js");
      const config = {
        clientId: NYLAS_CLIENT_ID,
        redirectUri: `${window.location.origin}/email-preferences-scheduler`,
        domain: "https://api.us.nylas.com/v3",
        hosted: true,
        accessType: "offline"
      };
      const session = await (async () => new identity.NylasSessions(config))();
      const nylasApiRequest = await (async () => new requestWrapper.NylasIdentityRequestWrapper(session))();
      let grantString = localStorage.getItem("grant");
      if (nylasAccountId && grantString) {
        const grant = JSON.parse(grantString);
        if (nylasAccountId != grant.grant_id) {
          localStorage.removeItem("grant");
          localStorage.removeItem("user");
          grantString = null;
        }
      }
      if (redirect) {
        const grant = await this.waitForLocalStorageKey("grant");
        if (grant) {
          const {
            grant_id: grantId,
            refresh_token: refreshToken
          } = JSON.parse(grant);
          if (refreshToken) {
            this.UPDATE_REFRESH_TOKEN({
              grantId,
              refreshToken
            });
          }
        }
      } else {
        if (!grantString) {
          await this.REFRESH_TOKEN_NYLAS({
            grantId: nylasAccountId
          });
        }
      }
      this.openNylasModal(nylasApiRequest);
    },
    openNylasModal(nylasApiRequest) {
      var _document$querySelect;
      (_document$querySelect = document.querySelector("nylas-scheduler-editor")) == null ? void 0 : _document$querySelect.remove();
      const schedulerModal = document.querySelector("#scheduler-modal");
      const schedulerEditorScript = require("../../../dashboard/components/nylas-scripts/nylas-scheduler-editor.es.js");
      schedulerEditorScript.defineCustomElement();
      const schedulerEditor = document.createElement("nylas-scheduler-editor");
      const pageStyles = "<div slot='custom-page-style-inputs'><label>Company logo URL</label><input-image-url name='company_logo_url'></input-image-url><label>Primary color</label><input-color-picker name='color'></input-color-picker><label>Submit button label</label><input-component name='submit_button_label' type='text'></input-component><label>Thank you message</label><textarea-component name='thank_you_message' placeholder='You`ll receive an email confirmation soon.'></textarea-component></div>";
      schedulerEditor.insertAdjacentHTML("afterbegin", pageStyles);
      schedulerEditor.nylasApiRequest = nylasApiRequest;
      schedulerEditor.schedulerPreviewLink = `https://book.nylas.com/us/${NYLAS_CLIENT_ID}/{slug}`;
      schedulerEditor.requiresSlug = true;
      schedulerEditor.eventOverrides = {
        schedulerConfigCloseClicked: async e => {
          var _document$querySelect2;
          (_document$querySelect2 = document.querySelector("nylas-scheduler-editor")) == null ? void 0 : _document$querySelect2.remove();
          this.shouldDisplayScheduler = false;
          e.preventDefault();
        }
      };
      schedulerEditor.defaultSchedulerConfigState = {
        selectedConfiguration: {
          requires_session_auth: false,
          // Creates a public Configuration.
          scheduler: {
            rescheduling_url: "https://book.nylas.com/us/reschedule/:booking_ref",
            cancellation_url: "https://book.nylas.com/us/cancel/:booking_ref"
          }
        }
      };
      schedulerModal.appendChild(schedulerEditor);
      this.shouldDisplayScheduler = true;
    },
    waitForLocalStorageKey(key, checkInterval = 500) {
      return new _Promise(resolve => {
        const interval = setInterval(() => {
          if (localStorage.getItem(key) !== null) {
            clearInterval(interval);
            resolve(localStorage.getItem(key));
          }
        }, checkInterval);
      });
    },
    emailAltText(provider) {
      return `connect-email-${provider}`;
    }
  })
});